import './buttons-onthulling.scss';

import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

function initButtonsOnthulling() {

	const roots = document.querySelectorAll( '[data-component="buttons-onthulling"]' );

	if ( ! roots.length ) {
		return;
	}

	const reduceMotionMq = window.matchMedia( '(prefers-reduced-motion: reduce)' );

	roots.forEach( ( root ) => {

		const bgEls = Array.from(
			root.querySelectorAll( '.b-buttonsOnthulling__highlightBg' )
		).filter(
			( el ) => el instanceof HTMLElement
		);

		if ( ! bgEls.length ) {
			return;
		}

		let tl = null;

		const setup = () => {

			if ( tl ) {
				tl.scrollTrigger?.kill();
				tl.kill();
				tl = null;
			}

			if ( reduceMotionMq.matches ) {
				gsap.set( bgEls, {
					scaleX: 1,
					transformOrigin: 'left center',
				} );

				return;
			}

			gsap.set( bgEls, {
				scaleX: 0,
				transformOrigin: 'left center',
			} );

			tl = gsap.timeline( {
				defaults: {
					duration: 1.15,
					ease: 'power3.out',
				},
				scrollTrigger: {
					trigger: root,
					start: 'top 50%',
					toggleActions: 'play none none reverse',
					invalidateOnRefresh: true,
				},
			} );

			bgEls.forEach( ( el, i ) => {

				if ( i === 0 ) {
					tl.to( el, { scaleX: 1 } );

					return;
				}

				tl.to( el, { scaleX: 1 }, '-=.55' );

			} );

		};

		setup();

		const onMotionPreferenceChange = () => {
			setup();
			ScrollTrigger.refresh();
		};

		if ( typeof reduceMotionMq.addEventListener === 'function' ) {
			reduceMotionMq.addEventListener( 'change', onMotionPreferenceChange );
		} else {
			reduceMotionMq.addListener( onMotionPreferenceChange );
		}

		root._buttonsOnthullingCleanup = () => {

			if ( typeof reduceMotionMq.removeEventListener === 'function' ) {
				reduceMotionMq.removeEventListener( 'change', onMotionPreferenceChange );
			} else {
				reduceMotionMq.removeListener( onMotionPreferenceChange );
			}

			if ( tl ) {
				tl.scrollTrigger?.kill();
				tl.kill();
				tl = null;
			}

		};

	} );

}

if ( document.readyState === 'loading' ) {

	document.addEventListener( 'DOMContentLoaded', initButtonsOnthulling );

} else {

	initButtonsOnthulling();

}
